module.exports = __webpack_public_path__ + "img/xuanxing_banner_hk.fb09ea03.jpg";